import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import './styles.less';
import { DOCUMENTS_TAB_ICONS, STATUS_INDICATOR } from '../../constants';
import { FileUploader } from '../../../../semantic-ui/components/file-uploader';
import { FormInputField } from '../../../../semantic-ui/components/form-input-field';
import { InfoIcon } from '../../../../components/info-icon';
import { CustomLoader } from '../../../../components/custom-loader';

const DocumentAttachmentFormView = ({
	documents,
	onFileUploadedChange,
	files,
	onUploadedFileDelete,
	formErrors,
	isFormLoading,
}) => {
	if (isFormLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="document-attachment-form">
			{documents.map(item => (
				<div className="document-attachment-form__row" key={item.name}>
					<div className="document-attachment-form__column">
						<div className="document-attachment-form__inner-row">
							<div className="document-attachment-form__date-status-indicator">
								<InfoIcon popupContent={STATUS_INDICATOR} />
							</div>
							<img src={DOCUMENTS_TAB_ICONS[item.icon]} alt={item.icon} />
							<span className="document-attachment-form__document-text document-attachment-form__document-text_bold">
								{item.name}
							</span>
							{item.is_other && (
								<div className="document-attachment-form__document-name">
									<Field
										name="document_name"
										type="text"
										component={FormInputField}
										autoComplete="off"
										placeholder="Название документа"
									/>
									{formErrors.document_name && (
										<div className="document-attachment-form__error">
											{formErrors.document_name}
										</div>
									)}
								</div>
							)}
						</div>
						{formErrors[item.key] && (
							<div className="document-attachment-form__error">{formErrors[item.key]}</div>
						)}
					</div>
					<div className="document-attachment-form__files">
						<FileUploader
							links={files[item.key] || []}
							onFileUploadedChange={e => {
								return onFileUploadedChange(e, item.key);
							}}
							onUploadedFileDelete={(_, name) => onUploadedFileDelete(name, item.key)}
							isOnlyOneFileToUpload={!item.is_multiple}
						/>
					</div>
				</div>
			))}
		</div>
	);
};

DocumentAttachmentFormView.propTypes = {
	documents: PropTypes.arrayOf(PropTypes.shape({})),
	files: PropTypes.object,
	onFileUploadedChange: PropTypes.func.isRequired,
	onUploadedFileDelete: PropTypes.func.isRequired,
	formErrors: PropTypes.objectOf(PropTypes.string),
	isFormLoading: PropTypes.bool.isRequired,
};

export { DocumentAttachmentFormView };
